// @flow
import {
  middleware as protectedMiddleware,
  getAccessToken
} from "redux-jwt-protected-middleware"
import {
  refreshTokens,
  nonAsyncAccessToken,
  nonAsyncRefreshToken
} from "../Auth"

import type { Config } from "redux-jwt-protected-middleware"

const config: Config = {
  currentAccessToken: () => nonAsyncAccessToken(),
  currentRefreshToken: () => nonAsyncRefreshToken(),
  handleRefreshAccessToken: (refreshToken, store) =>
    new Promise(async (resolve, reject) => {
      try {
        const json = await refreshTokens(refreshToken)
        if (json.success === false) {
          reject(Error("Could not refresh authentication token."))
        } else {
          resolve(json.data.accessToken)
        }
      } catch (error) {
        reject(error)
      }
    }),
  handleAuthenticationError: (error: any, store: any) => {
    console.log(error)
  }
}

export const fetchToken = getAccessToken(config)
export default protectedMiddleware(config)



// WEBPACK FOOTER //
// ./src/config/protectedMiddleware.js